<template>
  <div id="app">
    <navbar v-if="showNavbar" />
    <router-view />
    <app-footer v-if="showFooter" />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import AppFooter from '@/components/Footer.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'App',
  components: {
    Navbar,
    AppFooter
  },
  setup() {
    const route = useRoute()
    
    const showNavbar = computed(() => {
      return true
    })
    
    const showFooter = computed(() => {
      // 对于登录和注册页面，我们仍然不显示页脚
      return !['Login', 'Register'].includes(route.name)
    })
    
    return {
      showNavbar,
      showFooter
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
